import { lazy, Suspense } from 'react'
import { useParams } from '@tanstack/react-router'
import { StripeConnectBannerFallback } from '@/components/stripe-connect/StripeConnectFallback'

const StripeConnectNotificationBannerSurface = lazy(
  () => import('@/components/stripe-connect/StripeConnectNotificationBannerSurface')
)

export default function StripeConnectAlertsPanel({
  organizationId,
  accountContext = 'current',
  title = 'Stripe Account Alerts',
  description = 'Review important Stripe updates before they interrupt payouts or payments.',
  showSectionCard = true,
  showSectionHeader = true,
  hideWhenNoRequiredActions = false,
  initiallyVisible = false,
  showInitialPlaceholder = false,
  noActionsNeededStateMode = 'never',
  panelClassName,
  subtleBorder = false,
}) {
  const { orgId } = useParams({ strict: false })
  const resolvedOrganizationId = organizationId ?? orgId

  return (
    <Suspense
      fallback={
        showInitialPlaceholder ? (
          <StripeConnectBannerFallback
            title={title}
            description={description}
            showSectionCard={showSectionCard}
            showSectionHeader={showSectionHeader}
            panelClassName={panelClassName}
          />
        ) : null
      }
    >
      <StripeConnectNotificationBannerSurface
        organizationId={resolvedOrganizationId}
        accountContext={accountContext}
        title={title}
        description={description}
        showSectionCard={showSectionCard}
        showSectionHeader={showSectionHeader}
        hideWhenNoRequiredActions={hideWhenNoRequiredActions}
        initiallyVisible={initiallyVisible}
        noActionsNeededStateMode={noActionsNeededStateMode}
        panelClassName={panelClassName}
        subtleBorder={subtleBorder}
      />
    </Suspense>
  )
}
